// ======================================================================
// File Name       : ContentHistoryDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getEachDrillEnforceStatusSummary, getHistoryListByItemList, resetData } from '../../../actions/UserHistoryContentAction';
import { searchDrillList } from '../../../actions/content/ContentDrillAction';
import Header from '../../../components/Header';
import ContentHistoryDetail from '../../../components/userHistory/content/ContentHistoryDetail';
import { DRILL_KIND_FOR_DISPLAY_BAR_CHART } from '../../../constants/ContentHistoryConstant';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import CustomLink from '../../../components/button/CustomLink';
import { USER_HISTORY_CONTENT_LIST } from '../../../constants/PathConstants';

class ContentHistoryDetailContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contentSecernId: null,
      itemSecernIdList: null,
      learningHistorySortType: -1,
      ascendingDescendingSort: 0,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      isDisplayBarGraph: false,
    };

    this.onSearchData = this.onSearchData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goBack = this.goBack.bind(this);
  }

  componentWillMount() {
    const { userHistoryContent, match } = this.props;
    const { itemList, contentList } = userHistoryContent;
    let { isDisplayBarGraph } = this.state;
    if (match.params.id && itemList && itemList.length) {
      const itemSecernIdList = [];
      itemList.forEach((item) => {
        if (item.itemSecernId === match.params.id) {
          if (itemSecernIdList.indexOf(item.itemSecernId) < 0) {
            itemSecernIdList.push(item.itemSecernId);
          }
        }
      });
      this.setState({ contentSecernId: match.params.id, itemSecernIdList },
        () => {
          this.onSearchData();
        },
      );

      // #7386 START
      if (contentList && contentList.length) {
        const itemDetail = $.grep(itemList, (e) => e.itemSecernId === match.params.id);
        const selectedItem = itemDetail[0];
        const contentSecernId = selectedItem && selectedItem.contentInfo && selectedItem.contentInfo.contentSecernId;
        // #7464 START
        if (contentSecernId) {
          const drillParam = {
            drillSearchInfo: {
              drillSecernId: contentSecernId,
            },
          };
          this.props.dispatch(searchDrillList(drillParam)).then(() => {
            const { drillListInfo } = this.props;
            const { drillList } = drillListInfo;
            if (drillList && drillList[0]) {
              isDisplayBarGraph = DRILL_KIND_FOR_DISPLAY_BAR_CHART.indexOf(drillList[0].drillKind) > -1;
              isDisplayBarGraph && this.getEachDrillEnforceStatusSummary();
              this.setState({
                isDisplayBarGraph,
              });
            }
          });
        }
        // #7464 END
      }
      // #7386 END
    } else {
      this.props.history.goBack();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { userHistoryContent, match } = nextProps;
    const {
      itemList,
      userInfo,
      learningHistoryList,
      groupList,
      groupRelationList,
      recordDetailNum,
      drillImplementationStatusList,
    } = userHistoryContent;
    const itemDetail = $.grep(itemList, (e) => e.itemSecernId === match.params.id);
    if (itemDetail.length > 0) {
      this.setState({
        itemDetail: itemDetail[0],
      });
    }

    this.setState({
      learningHistoryList,
      groupList,
      groupRelationList,
      userInfo,
      recordDetailNum,
      drillImplementationStatusList,
    });
  }

  // #7464 START
  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(resetData());
  }
  // #7464 END

  onSearchData() {
    this.setState(
      {
        startPosition: 0,
      },
      () => {
        this.getHistoryListByItemList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  getHistoryListByItemList(selectTargetData) {
    const { userHistoryContent } = this.props;
    const { learningEndTimeFrom, learningEndTimeTo } = userHistoryContent;
    const {
      itemSecernIdList,
      startPosition,
      returnMaxNum,
      ascendingDescendingSort,
      learningHistorySortType,
    } = this.state;
    const searchInfo = {
      itemList: (itemSecernIdList && itemSecernIdList.length) ? itemSecernIdList : null,
      ascendingDescendingSort: this.state.ascendingDescendingSort,
      learningHistorySortType:
      this.state.learningHistorySortType < 0 ? undefined : this.state.learningHistorySortType,
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
      learningEndTimeFrom,
      learningEndTimeTo,
    };
    this.props.dispatch(getHistoryListByItemList(searchInfo, selectTargetData));
  }

  // #7386 START
  getEachDrillEnforceStatusSummary() {
    const { userHistoryContent, match, dispatch } = this.props;
    const { learningEndTimeFrom, learningEndTimeTo } = userHistoryContent;
    const params = {
      itemSecernId: match.params.id,
      learningEndTimeFrom,
      learningEndTimeTo,
    };
    dispatch(getEachDrillEnforceStatusSummary(params));
  }
  // #7386 END

  getStartEndData(startPosition) {
    this.setState(
      {
        startPosition,
      },
      () => {
        this.getHistoryListByItemList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  handleSortState(row) {
    this.setState(
      {
        learningHistorySortType: row.sortBy,
        ascendingDescendingSort: row.sortState,
      },
      () => {
        this.getHistoryListByItemList(SELECT_TARGET_DATA.DATA);
      },
    );
  }

  goBack() {
    this.props.history.goBack();
  }

  render() {
    const { userHistoryContent } = this.props;
    let { learningEndTimeFrom, learningEndTimeTo, histogramDataMax } = userHistoryContent;
    const { itemInfo } = userHistoryContent;
    if (learningEndTimeFrom || learningEndTimeTo) {
      learningEndTimeFrom = learningEndTimeFrom ? learningEndTimeFrom.substring(0, 10).replace(/-/g, '/') : '';
      learningEndTimeTo = learningEndTimeTo ? learningEndTimeTo.substring(0, 10).replace(/-/g, '/') : '';
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={USER_HISTORY_CONTENT_LIST}
          text="学習履歴一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="コンテンツ別履歴情報の詳細"/>
        <ContentHistoryDetail
          itemInfo={itemInfo}
          userInfo={this.state.userInfo}
          groupRelationList={this.state.groupRelationList}
          groupList={this.state.groupList}
          learningHistoryInfo={this.state.learningHistoryList}
          learningEndTimeFrom={learningEndTimeFrom}
          learningEndTimeTo={learningEndTimeTo}
          recordNum={this.state.recordDetailNum ? this.state.recordDetailNum : 0}
          startPosition={this.state.startPosition}
          getStartEndData={this.getStartEndData}
          handleSortState={this.handleSortState}
          goBack={this.goBack}
          itemDetail={this.state.itemDetail}
          dataSort={this.state}
          drillImplementationStatusList={this.state.drillImplementationStatusList}
          isDisplayBarGraph={this.state.isDisplayBarGraph}
          histogramDataMax={histogramDataMax}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userHistoryContent, content } = state;
  const { learningHistoryList } = userHistoryContent;
  const { drillListInfo } = content;
  return {
    userHistoryContent,
    learningHistoryList,
    drillListInfo,
  };
};

export default connect(mapStateToProps)(ContentHistoryDetailContainer);
